import { BaseAPI } from '../../BaseApi';
import { UUID } from '../../../types/shared/UUID';
import { IInternalContactResponse, IUpdateInternalContactRequest } from '../../../types/contacts/IInternalContact';
import { ICreateInternalContactData } from '../../../types/contacts/CreateInternalContact';
import { eAPITags } from '../../eAPITags';

interface CreateInternalContact {
  orderId: UUID;
  contact: ICreateInternalContactData;
}

interface UpdateInternalContact {
  orderId: UUID;
  contact: IUpdateInternalContactRequest;
}

interface DeleteInternalContact {
  orderId: UUID;
  contactId: UUID;
}

export const InternalContactsApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listInternalOrderContacts: build.query<IInternalContactResponse[], UUID>({
      query: (orderId) => `/timber/api/internal/orders/${orderId}/internal_contacts`,
      providesTags: (result, error, orderId) => [
        { type: eAPITags.OrderInternalContacts, id: orderId },
        { type: eAPITags.OrderInternalContacts, id: 'LIST' },
      ],
    }),

    createInternalOrderContact: build.mutation<IInternalContactResponse, CreateInternalContact>({
      query: ({ orderId, contact }) => ({
        url: `/timber/api/internal/orders/${orderId}/internal_contacts`,
        method: 'POST',
        body: contact,
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderInternalContacts, id: orderId }],
    }),

    updateInternalOrderContact: build.mutation<IInternalContactResponse, UpdateInternalContact>({
      query: ({ orderId, contact }) => ({
        url: `/timber/api/internal/orders/${orderId}/internal_contacts/${contact.id}`,
        method: 'PUT',
        body: contact,
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderInternalContacts, id: orderId }],
    }),

    deleteInternalOrderContact: build.mutation<void, DeleteInternalContact>({
      query: ({ orderId, contactId }) => ({
        url: `/timber/api/internal/orders/${orderId}/internal_contacts/${contactId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderInternalContacts, id: orderId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListInternalOrderContactsQuery,
  useCreateInternalOrderContactMutation,
  useUpdateInternalOrderContactMutation,
  useDeleteInternalOrderContactMutation,
} = InternalContactsApi;
